import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
    PadContainer,
    HighlightedSection,
    HorizontalFlex,
    ButtonWithIcon,
    icons,
    AnimatedLoader,
} from 'smartsuite-ui';
import {
    saveFavorite,
    deleteFavorite,
    getIsFavorite,
    isFavoriteDisabled,
} from '../../shared/filtering/favoriteUtils';

export default function SavedDashboardItem({
    pageTitle,
    savedDashboard,
    setDashboardToRemove,
    setIsConfirmModalVisible,
    siteMapKey,
    viewKey,
}) {
    const [isFavorite, setIsFavorite] = useState(null);

    useEffect(() => {
        if (siteMapKey && !isFavoriteDisabled) {
            getIsFavorite(siteMapKey, savedDashboard.key).then(setIsFavorite);
        }
    }, [savedDashboard.key, siteMapKey]);

    function onSaveFavorite() {
        saveFavorite(
            siteMapKey,
            `${pageTitle}: ${savedDashboard.name}`,
            'Manage Favorite',
            savedDashboard.key,
            viewKey,
            savedDashboard.name
        ).then(() => setIsFavorite(true));
    }

    function onDeleteFavorite() {
        deleteFavorite(
            siteMapKey,
            `${pageTitle}: ${savedDashboard.name}`,
            'Manage Favorite',
            savedDashboard.key
        ).then(() => setIsFavorite(false));
    }

    // eslint-disable-next-line complexity
    function renderFavoriteIcon() {
        if (!siteMapKey || isFavoriteDisabled) {
            return null;
        }

        if (isFavorite === null) {
            return (
                <PadContainer cssClassModifiers={['pad-medium']}>
                    <AnimatedLoader />
                </PadContainer>
            );
        }

        return (
            <ButtonWithIcon
                iconClass={isFavorite ? icons.favoriteFilled : icons.favorite}
                onClick={isFavorite ? onDeleteFavorite : onSaveFavorite}
            />
        );
    }

    return (
        <PadContainer cssClassModifiers={['pad-small', 'no-pad-left-right']}>
            <HighlightedSection>
                <PadContainer cssClassModifiers={['pad-medium']}>
                    <HorizontalFlex cssClassModifiers={['space-between']}>
                        <span className="manage-saved-searches-modal__label">
                            {savedDashboard.name}
                        </span>
                        <HorizontalFlex>
                            {renderFavoriteIcon()}
                            <ButtonWithIcon
                                iconClass={icons.trash}
                                onClick={() => {
                                    setDashboardToRemove({
                                        name: savedDashboard.name,
                                        key: savedDashboard.key,
                                    });
                                    setIsConfirmModalVisible(true);
                                }}
                            />
                        </HorizontalFlex>
                    </HorizontalFlex>
                </PadContainer>
            </HighlightedSection>
        </PadContainer>
    );
}

SavedDashboardItem.propTypes = {
    pageTitle: PropTypes.string.isRequired,
    savedDashboard: PropTypes.instanceOf(Object).isRequired,
    setDashboardToRemove: PropTypes.func.isRequired,
    setIsConfirmModalVisible: PropTypes.func.isRequired,
    siteMapKey: PropTypes.string,
    viewKey: PropTypes.string.isRequired,
};

SavedDashboardItem.defaultProps = {
    siteMapKey: undefined,
};
